define('models/NewsFlagCollection',['underscore','ObjectCollection','LocalStorage','models/NewsFlagModel'],function (_,ObjectCollection,LocalStorage,NewsModel) {
    //
    // Collection News
    //
    var NewsFlagCollectionPrototype = {
        
        name:'NewsFlagCollection',
        route:'apiNewsFlagCollection',
        model:NewsModel,
        initialize:function(){
            // ObjectCollection constructor heritage
            ObjectCollection.prototype.initialize.apply(this,arguments);
            //
        },
        getAllNewsFlag:function(){
            return this.findWhere({is_all_news:true});
        },
        getFilters:function () {
            // retourne les filtres de la page actualités
            return new NewsFlagCollection(this.filter(function(flag){
                return flag.isAllNews() || (flag.get('visible') && flag.get('is_news') && !!flag.get('news').length)
            }))
        }
    };

    var NewsFlagCollection = ObjectCollection.extend(LocalStorage).extend(NewsFlagCollectionPrototype);

    return NewsFlagCollection;
});
